import {call, put, takeEvery} from 'redux-saga/effects'
import * as errorActions from "../error/actions";
import {setUser} from '../user/saga'
import {getSubscriptions} from '../subscription/saga.js'
import {initialiseSearch} from '../documentSearch/saga.js'

export const SAGA_INITIALISE = "SAGA_INITIALISE";

export class Saga {
  static initialise() {
    return {
      type: SAGA_INITIALISE
    }
  };
}

function* initApp() {
  try {
    yield call(setUser);
    yield call(getSubscriptions);
    yield call(initialiseSearch);
  }
  catch (e) {
    yield put(errorActions.Saga.setError(e));
  }
}


function* initSaga() {
  yield takeEvery(SAGA_INITIALISE, initApp);
}

export {initSaga};